import { IGroupMatches } from "@grassrootly/api/entities/IGroupsMatches";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface GroupMatches {
  group_matches: { [key: string]: IGroupMatches };
}

const initialState: GroupMatches = {
  group_matches: {},
};

const groupMatchesSlice = initReducer({
  name: "group-matches",
  initialState,
  reducers: {
    setGroupMatches: (state: GroupMatches, action: PayloadAction<IGroupMatches>) => {
      state.group_matches[action.payload.groupId] = action.payload;
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<GroupMatches> = {
  key: "group-matches",
  storage: AsyncStorage,
};

export const groupMatchesActions = groupMatchesSlice.actions;

export default createPersistReducer(persistConfig, groupMatchesSlice.reducer);
